import { render, staticRenderFns } from "./InstallPromotionCard.vue?vue&type=template&id=47d0b834&scoped=true&"
import script from "./InstallPromotionCard.vue?vue&type=script&lang=js&"
export * from "./InstallPromotionCard.vue?vue&type=script&lang=js&"
import style0 from "./InstallPromotionCard.vue?vue&type=style&index=0&id=47d0b834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d0b834",
  null
  
)

export default component.exports